export default [
    {
        path: "/help/tutorial",
        name: "help-tutorial",
        component: () => import("@/views/help/tutorial.vue"),
    }
]